import { IColumns } from '../../../../components/Table'

export enum RiskLevel {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
}

export type StakingColumnsType =
  | 'id'
  | 'asset'
  | 'rewardFee'
  | 'stakingFee'
  | 'riskLevel'
  | 'minTrade'
  | 'updated'
  | 'threeActions'

export const columns: IColumns<StakingColumnsType>[] = [
  {
    id: 'id',
    label: 'ID',
  },
  {
    id: 'asset',
    label: 'ASSET',
  },
  {
    id: 'rewardFee',
    label: 'REWARD FEE',
    format: (value) => (value ? `${value}%` : '-'),
  },
  {
    id: 'stakingFee',
    label: 'STAKING FEE',
    format: (value) => (value ? `${value}%` : '-'),
  },
  {
    id: 'riskLevel',
    label: 'RISK LEVEL',
  },
  {
    id: 'minTrade',
    label: 'MIN TRADE',
    format: (value) => (value ? `${value}$` : '-'),
  },
  {
    id: 'updated',
    label: 'LAST EDIT',
    format: (value) =>
      value
        ? new Date(value as Date).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })
        : '-',
  },
  {
    id: 'threeActions',
    label: 'ACTIONS',
  },
]
